import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/icons/link.svg'


const _hoisted_1 = { id: "viewport-markers" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "In beeld", -1)
const _hoisted_3 = {
  class: "markers",
  "aria-live": "polite"
}
const _hoisted_4 = ["aria-current", "aria-hidden", "onClick"]
const _hoisted_5 = ["href"]
const _hoisted_6 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.markers, (marker) => {
        return _withDirectives((_openBlock(), _createElementBlock("button", {
          class: _normalizeClass(["row", [{selected: marker.selected}, `marker-${marker.kaart_id}`]]),
          tabindex: "0",
          key: marker.kaart_id,
          style: _normalizeStyle([
          {'border-color': `${$setup.groups[marker.groupName].color}`},
          (marker.selected) ? {
            'background-color': `${$setup.groups[marker.groupName].color}99`,
            'color': '#000'
          } : {}
        ]),
          "aria-current": marker.selected,
          "aria-hidden": !($setup.groups[marker.groupName].active && marker.active),
          onClick: ($event: any) => ($setup.selectMarker(marker.kaart_id))
        }, [
          _createTextVNode(_toDisplayString(marker.titel) + " ", 1),
          (marker.project_url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: marker.project_url,
                target: "_blank"
              }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: `Bekijk project: ${marker.titel} (opent in nieuw tablad)`
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 14, _hoisted_4)), [
          [_vShow, $setup.groups[marker.groupName].active && marker.active]
        ])
      }), 128))
    ])
  ]))
}